import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { Layout } from '@/components/layout/Layout'
import { LoadingScreen } from '@/components/ui/loading-screen'

// Auth pages
import { LoginPage } from '@/pages/auth/LoginPage'
import { RegisterPage } from '@/pages/auth/RegisterPage'

// Game pages
import { GamePage } from '@/pages/game/GamePage'
import { LevelSelectPage } from '@/pages/game/LevelSelectPage'
import { ResearchPage } from '@/pages/game/ResearchPage'
import { LeaderboardPage } from '@/pages/game/LeaderboardPage'

// Admin pages
import { AdminDashboard } from '@/pages/admin/AdminDashboard'
import { AdminTowers } from '@/pages/admin/AdminTowers'
import { AdminEnemies } from '@/pages/admin/AdminEnemies'
import { AdminAnalytics } from '@/pages/admin/AdminAnalytics'

// Main landing page
import { HomePage } from '@/pages/HomePage'

function App() {
  const { user, isLoading } = useAuthStore()

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />

        {/* Auth routes */}
        <Route
          path="/login"
          element={user ? <Navigate to="/game" replace /> : <LoginPage />}
        />
        <Route
          path="/register"
          element={user ? <Navigate to="/game" replace /> : <RegisterPage />}
        />

        {/* Protected routes with shared layout */}
        <Route
          element={
            user ? (
              <Layout />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        >
          <Route path="/game">
            <Route index element={<Navigate to="/game/play" replace />} />
            <Route path="play" element={<GamePage />} />
            <Route path="levels" element={<LevelSelectPage />} />
            <Route path="research" element={<ResearchPage />} />
            <Route path="leaderboard" element={<LeaderboardPage />} />
          </Route>

          <Route
            path="/admin"
            element={
              user && user.role === 'admin' ? <Outlet /> : <Navigate to="/game" replace />
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="towers" element={<AdminTowers />} />
            <Route path="enemies" element={<AdminEnemies />} />
            <Route path="analytics" element={<AdminAnalytics />} />
          </Route>
        </Route>

        {/* 404 route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  )
}

export default App